import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-select-icon-container',
    templateUrl: './select-icon-container.component.html',
    styleUrls: ['./select-icon-container.component.css'],
    standalone: false
})
export class SelectIconContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
